import Vue from 'vue'
import Vuex from "vuex"

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    quotesCount: 0,
    quotes: []
  },
  getters: {
    latestQuote(state) {
      if (state.quotes.length === 0) return null

      return state.quotes[state.quotes.length - 1];
    },
    allQuotes(state) {
      return state.quotes;
    }
  },
  mutations: {
    addQuote(state, {fileName, width, height, depth, volume}) {
      state.quotesCount++
      state.quotes.push({
        id: state.quotesCount,
        fileName,
        width,
        height,
        depth,
        volume
      })
    },
    updateQuote(state, payload) {
      const id = payload.id
      const quoteIndex = state.quotes.findIndex(quote => quote.id === id)
      Vue.set(state.quotes, quoteIndex, Object.assign({}, state.quotes[quoteIndex], payload))
    }
  }
})